import { useState, useEffect, FC } from 'react';
import { DeviceManager } from 'src/utils';
import { Loader } from '../loader/Loader';
import { Stack } from '@mui/material';

interface IframeItemProps {
  item: string;
  index: number;
  useGoogleViewer?: boolean;
}

export const IframeItem: FC<IframeItemProps & { children?: any }> = ({
  item,
  index,
  useGoogleViewer,
}) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [key, setKey] = useState(index);
  const src =
    (DeviceManager.isMobile() || useGoogleViewer) && item.includes('.pdf')
      ? `https://docs.google.com/viewer?url=${encodeURIComponent(item)}&embedded=true&preview=true`
      : item;

  useEffect(() => {
    if (index) {
      setKey(index);
    }
  }, [index]);

  useEffect(() => {
    let interval;
    if (!iframeLoaded) {
      interval = setInterval(() => {
        setKey((prevKey) => prevKey + 1);
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [iframeLoaded]);

  return (
    <>
      {!iframeLoaded && (
        <Stack
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Loader />
        </Stack>
      )}
      <iframe
        key={key}
        src={src}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        title={`iframe-${index}`}
        style={{
          width: '100%',
          height: '100%',
          minHeight: '190px',
          visibility: iframeLoaded ? 'visible' : 'hidden',
        }}
        onLoad={() => {
          setIframeLoaded(true);
        }}
        onError={(e) => console.log('iframe error', e)}
      />
    </>
  );
};
